import { Component, Prop, PropSync, Vue } from 'vue-property-decorator'
import CustomOptionPopover from '@/components/sideBar/CustomOptionPopover.vue'
import OptionNav from '@/components/sideBar/OptionNav.vue'
import SubMenu from '@/components/sideBar/SubMenu.vue'
import { CustomLabelFunction } from '@/types/common.type'

@Component({
    components: {
        CustomOptionPopover,
        OptionNav,
        SubMenu
    }
})
export default class SidebarFiltersCustomFilterCompact<Option extends object = any> extends Vue {
    @PropSync('selectedOption', { type: Object, default: null })
    syncedSelectedOption!: Option

    @Prop({ type: Object, default: null })
    defaultOption!: Option

    @Prop({ type: Array, default: () => [] })
    options!: Array<Option>

    @Prop({ type: String, default: 'label' })
    label!: keyof Option

    @Prop({
        type: Function,
        default: (option: Option, label: keyof Option): Option | Option[keyof Option] | '' => {
            if (option) {
                return label ? option[label] : option
            }
            return ''
        }
    })
    customLabel!: CustomLabelFunction<Option>

    @Prop({ type: Object })
    store!: any

    @Prop({ type: Boolean, default: false })
    disableAddFilter!: boolean
}
